module.exports = __webpack_public_path__ + "static/media/olderadultWhite.f450a803.svg";